// @flow
/* globals document, window */
import React from "react";
import LayoutSellerLead from "./LayoutSellerLead";
import { SellerLeadProvider } from "../common/SellerLeadContext";
import { GlobalProvider } from "../common/GlobalContext";

type $Props = {
  globalGA: string,
  privacyPolicy: Object,
  accessibility: Object,
  tenantConfig: Object,
  theme: Object, // theme from the API/site settings, not the react-jss theme
  page: string,
  mapProvider: Object,
  city: string,
  state: string,
  geoCodeUrl: string,
  homepageSearchHeroImage: string,
};

class SellerLead extends React.Component<$Props> {
  render() {
    const {
      page,
      mapProvider,
      city,
      state,
      theme,
      tenantConfig,
      privacyPolicy,
      accessibility,
      homepageSearchHeroImage,
      geoCodeUrl,
    } = this.props;

    return (
      <GlobalProvider
        theme={theme}
        tenantConfig={tenantConfig}
        privacyPolicy={privacyPolicy}
        accessibility={accessibility}
        mapProvider={mapProvider}
      >
        <SellerLeadProvider
          page={page}
          city={city}
          state={state}
          geoCodeUrl={geoCodeUrl}
        >
          <LayoutSellerLead homepageSearchHeroImage={homepageSearchHeroImage} />
        </SellerLeadProvider>
      </GlobalProvider>
    );
  }
}
export default SellerLead;
